export const INSCRIPTION_CREE_SUCCES = "INSCRIPTION_CREE_SUCCES";
export const INSCRIPTION_CREE_ECHEC = "INSCRIPTION_CREE_ECHEC";
export const INSCRIPTION_CREE_REQUETTE = "INSCRIPTION_CREE_REQUETTE";
export const INSCRIPTION_CREE_RESET = "INSCRIPTION_CREE_RESET";

export const INSCRIPTION_LISTE_SUCCES = "INSCRIPTION_LISTE_SUCCES";
export const INSCRIPTION_LISTE_ECHEC = "INSCRIPTION_LISTE_ECHEC";
export const INSCRIPTION_LISTE_REQUETTE = "INSCRIPTION_LISTE_REQUETTE";
